// extracted by mini-css-extract-plugin
module.exports = {"alertWrapper":"ExternalLinkConfirmation_alertWrapper__p1niP","footerContent":"ExternalLinkConfirmation_footerContent__82CqY"};